import script from "./LlHtmlViewerIframe.vue?vue&type=script&setup=true&lang=js"
export * from "./LlHtmlViewerIframe.vue?vue&type=script&setup=true&lang=js"

import "./LlHtmlViewerIframe.vue?vue&type=style&index=0&id=72916994&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72916994"]])

export default __exports__